// Reveal only the tab strip; never scroll the entire product page on selection.
function kohlRevealProductTab(button, behavior = 'auto') {
  const strip = button?.closest('.main-product__tabs');
  if (!strip || strip.scrollWidth <= strip.clientWidth) return;
  const viewport = strip.getBoundingClientRect();
  const tab = button.getBoundingClientRect();
  let left = strip.scrollLeft;
  if (tab.left < viewport.left || tab.width > strip.clientWidth) {
    left += tab.left - viewport.left;
  } else if (tab.right > viewport.right) {
    left += tab.right - viewport.right;
  } else {
    return;
  }
  strip.scrollTo({
    left: Math.max(0, Math.min(left, strip.scrollWidth - strip.clientWidth)),
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior
  });
}

function openTab(evt, tabName, tabWrapper) {
  const tabWrapperElement = document.getElementById(tabWrapper);
  if (!tabWrapperElement) return;

  // Hide all tab contents within the given tabWrapper
  const tabcontents = tabWrapperElement.querySelectorAll(
    '.main-product__tab-content'
  );
  tabcontents.forEach(content => {
    content.style.display = 'none';
  });

  // Remove 'active' class from all tab links within the given tabWrapper
  const tablinks = tabWrapperElement.querySelectorAll(
    '.main-product__tab'
  );
  tablinks.forEach(link => {
    link.classList.remove('active');
  });

  // Show the current tab and add the 'active' class to the button that opened the tab
  const currentTabContent = tabWrapperElement.querySelector(
    `#${tabName}`
  );
  if (currentTabContent) {
    currentTabContent.style.display = 'block';
    if (evt.currentTarget) {
      evt.currentTarget.classList.add('active');
      kohlRevealProductTab(evt.currentTarget, evt.isTrusted ? 'smooth' : 'auto');
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  function simulateClick(element) {
    const event = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });
    element.dispatchEvent(event);
  }

  // Get all the wrapper elements for each instance
  const tabWrappers = document.querySelectorAll(
    '.main-product__tabs-wrapper'
  );

  // Loop through each instance to find and click the default open tab
  tabWrappers.forEach(wrapper => {
    // get the wrapperID only if it exists
    const wrapperID = wrapper.getAttribute('id');
    if (!wrapperID) return;

    // get all the tabs marked as default open for every instance
    const defaultOpenTabs = wrapper.querySelectorAll(
      '.main-product__tab[data-default-open]'
    );

    // Loop through each default open tab and click it
    defaultOpenTabs.forEach(tabToClick => {
      simulateClick(tabToClick);
    });
  });
});

document.addEventListener('focusin', function (event) {
  if (event.target.matches('.main-product__tabs .main-product__tab')) {
    kohlRevealProductTab(event.target);
  }
});


// Progressive enhancement: without JavaScript the complete description stays visible.
if (!customElements.get('kohl-product-description')) {
  customElements.define('kohl-product-description', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      this.content = this.querySelector('[data-description-content]');
      this.toggle = this.querySelector('[data-description-toggle]');
      if (!this.content || !this.toggle) return;
      this.expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      this.onToggle = () => {
        this.expanded = !this.expanded;
        this.render();
        // After collapsing a long text, keep its beginning and the toggle in view.
        if (!this.expanded && this.toggle.getBoundingClientRect().top < 0) {
          this.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'auto' });
        }
      };
      this.toggle.addEventListener('click', this.onToggle);
      this.lastWidth = -1;
      this.observer = new ResizeObserver(() => {
        const width = this.content.getBoundingClientRect().width;
        if (width !== this.lastWidth) {
          this.lastWidth = width;
          this.refresh();
        }
      });
      this.observer.observe(this.content);
      this.refresh();
      document.fonts?.ready.then(() => {
        if (this.isConnected) this.refresh();
      });
    }

    refresh() {
      // Hidden tabs are measured when they become visible, not while width is zero.
      if (!this.content.getBoundingClientRect().width) return;
      const text = this.content.querySelector('p, li') || this.content;
      const style = getComputedStyle(text);
      const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
      this.content.style.setProperty('--kohl-description-line-height', `${lineHeight}px`);
      this.collapsible = this.content.scrollHeight > lineHeight * 3 + 1;
      if (!this.collapsible) this.expanded = false;
      this.render();
    }

    render() {
      this.classList.toggle('is-collapsible', this.collapsible);
      this.classList.toggle('is-expanded', this.expanded);
      this.toggle.hidden = !this.collapsible;
      this.toggle.setAttribute('aria-expanded', String(this.expanded));
      this.toggle.textContent = this.expanded ? this.toggle.dataset.lessText : this.toggle.dataset.moreText;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.observer?.disconnect();
      if (this.onToggle) this.toggle?.removeEventListener('click', this.onToggle);
    }
  });
}
